import { root } from './file-upload';

export const fileUpload = {
  ...root,
};
